import React from "react";
import CdzyxxPrint from '../print/Bdd/cdzyxx/CdzyxxPrint';
import PrintTemplate from './printTemplate';
import ScjtzyxyPrint from '../print/Bdd/scjtzyxy/ScjtzyxyPrint';
import GznyzyxyPrint from '../print/Bdd/gznyzyxy/GznyzyxyPrint';
import JxyykjxyPrint from '../print/Bdd/jxyykjxy/JxyykjxyPrint';
import FjlyzyxyPrint from '../print/Bdd/fjlyzyxy/FjlyzyxyPrint';

// 报到单，根据学校代码获取对应的报道单页面
export const bdd_school = [
    {dm: 'lydx', mc: '联奕大学', PrintComponent: PrintTemplate},
    {dm: 'other', mc: '其它基线大学', PrintComponent: PrintTemplate},
    {dm: 'cdfzxx', mc: '成都纺织高等专科学校', PrintComponent: CdzyxxPrint},
    {dm: 'scjtzyxy', mc: '四川交通职业技术学院', PrintComponent: ScjtzyxyPrint},
    {dm: 'gznyzyxy', mc: '贵州农业职业学院', PrintComponent: GznyzyxyPrint},
    {dm: 'jxyykjxy', mc: '江西应用科技学院', PrintComponent: JxyykjxyPrint},
    {dm: 'fjlyzyxy', mc: '福建林业职业技术学院', PrintComponent: FjlyzyxyPrint},
]

//根据schoolcode获取相应的组件
export const getBddComponent = (school, type) => {
    let res = undefined;
    var arr = [...bdd_school];
    arr = arr.filter(item => item.dm == school)
    if (arr.length > 0) {
        Object.getOwnPropertyNames(arr[0]).some((key) => {
            if (key.includes(type)) {
                res = arr[0][key];
                return true;
            }
        })
    }
    console.log(res)
    return res;
}

export const basePrintComponent = PrintTemplate;


// WEBPACK FOOTER //
// ./components/yxxc/print/Config.js